import React from 'react';

function VirtualHorseStatItem({data, index}) {
  const className = index % 2 === 0 ? 'stat-item light' : 'stat-item';
  const iconBaseURL = process.env.PUBLIC_URL + './assets/players/horse/';
  const scores = data['scores'].split(' ');

  const getFormattedData = () => {
    return new Date(data['date'] * 1000).toLocaleString('en-GB').replace(',', '');
  }

  return <div className={className}>
    <div className="result-info">
      <p className="info">ID: {data['game_id']}</p>
      <div className='info'>
        {
          scores.map((score, index) => <img src={iconBaseURL + parseInt(score) + '.png'} alt='' key={index}/>)
        }
      </div>
    </div>
    <div className="date-info">
      {getFormattedData()}
    </div>
  </div>
}

export default VirtualHorseStatItem;